import './App.css';
import { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Kitoltok from './Kitoltok';
import Felhasznalok from './Felhasznalok';
import Szovegek from './Szovegek';
import Templates from './Templates';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import { setUnauthorizedHandler } from './store/api';

function App() {
  const [page, setPage] = useState('kitoltesek');
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useState(() => localStorage.getItem('token'));

  const urlParams = new URLSearchParams(window.location.search);
  const resetToken = urlParams.get('token');

  const [view, setView] = useState(() => {
    if (resetToken) return 'reset';
    return localStorage.getItem('token') ? 'app' : 'login';
  });

  useEffect(() => {
    setUnauthorizedHandler(() => {
      localStorage.removeItem('token');
      setToken(null);
      setView('login');
    });
  }, []);

  const handleLogin = (t) => {
    localStorage.setItem('token', t);
    setToken(t);
    setView('app');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setView('login');
  };

  if (view === 'reset') {
    return (
      <ResetPassword
        resetToken={resetToken}
        onDone={() => {
          window.history.replaceState({}, '', window.location.pathname);
          setView('login');
        }}
      />
    );
  }
  if (view === 'forgot') return <ForgotPassword onBack={() => setView('login')} />;
  if (view === 'login') return <Login onLogin={handleLogin} onForgot={() => setView('forgot')} />;

  return (
    <div className="app-wrapper d-flex">
      <Navbar page={page} setPage={setPage} onLogout={handleLogout} />
      <div className="content-col flex-grow-1">
        {page === 'kitoltesek' && <Kitoltok />}
        {page === 'szovegek' && <Szovegek />}
        {page === 'sablonok' && <Templates />}
        {page === 'felhasznalok' && <Felhasznalok />}
      </div>
    </div>
  );
}

export default App;
